import { render } from "./IconPrinter.vue?vue&type=template&id=d88aa1c2"
const script = {}
script.render = render

export default script